export function getMonthCalendar(year: number, month: number) {
  const daysInMonth = new Date(year, month, 0).getDate();
  const firstDay = new Date(year, month - 1, 1).getDay();
  let shiftedFirstDay = (firstDay === 0) ? 6 : firstDay - 1; // Сдвиг на понедельник

  const calendar = [];
  let week = new Array(7).fill(null);

  for (let i = 0; i < shiftedFirstDay; i++) {
    week[i] = null; // Пустые ячейки перед началом месяца
  }

  for (let day = 1; day <= daysInMonth; day++) {
    week[shiftedFirstDay] = day;
    shiftedFirstDay++;

    if (shiftedFirstDay === 7) {
      calendar.push(week);
      week = new Array(7).fill(null);
      shiftedFirstDay = 0;
    }
  }

  if (week.some(day => day !== null)) {
    calendar.push(week);
  }

  return calendar;
  }